import { Box, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { FC, useCallback } from "react";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import api, { STATUS_CODE } from "src/framework/providers/api";
import { Projeto } from "../../types";
import adminStore from "src/store/AdminStore";

interface ModalReenviarNotaFiscalParams {
    open: boolean;
    closeModal: () => void;
    projeto: Projeto | null;
    onSuccess: () => void
}

export const ModalReenviarNotaFiscal: FC<ModalReenviarNotaFiscalParams> = ({ open, closeModal, projeto, onSuccess}) => {
    const onConfirm = useCallback(async () => {
        if (!projeto?.codigo_venda) return;

        // verifica vigência substituição EV
        let vigencia = true
        if (projeto?.id) {
            await adminStore.buscarProjeto(projeto.id, true).then(resp => {
                if (!resp?.length) vigencia = false;
            });
        }
        if (!vigencia) return;

        const response = await api.post({
            url: "/vendas/pedidos/reenviar_nota_fiscal",
            data: {
                codigo_venda: projeto.codigo_venda
            }
        })

        if (response.statusCode === STATUS_CODE.OK) {
            onSuccess();
            closeModal();
        }
    }, [closeModal, projeto?.codigo_venda])

    return (
        <Dialog
            open={open}
            onClose={closeModal}
            maxWidth='md'
        >
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Box component={"h2"}>Atenção!</Box>
                            <Box component={"span"}><strong>Reenviar Nota Fiscal</strong> do projeto - {projeto?.codigo_venda}</Box>
                            <Box component={"p"}>Ao reenviar a NF, o e-mail será enviado para o cliente e NF será sincronizada com pagamentos.</Box>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <FlatButton
                    color="inherit"
                    variant="contained"
                    disableElevation
                    text="Fechar"
                    onClick={closeModal}
                />
                <FlatButton
                    color="primary"
                    variant="contained"
                    disableElevation
                    text="Confirmar"
                    onClick={onConfirm}
                />
            </DialogActions>
        </Dialog>
    )
}

